import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { createTheme, StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { trTR } from "@mui/material/locale";
import ReduxNotificationHandler from "./util/ReduxNotificationHandler";
import { useDispatch, useSelector } from "react-redux";
import PrivateRoute from "./PrivateRoute";
import HomePage from "./pages/HomePage";
import PageLoading from "./components/PageLoading";

import { ActionType } from "./store/ActionType";

import MasterHomePage from "./pages/MasterHomePage";
import useGlobal from "./util/Global";
import { useAppCookies } from "./util/useAppCookies";
import CepTelConfirm from "./pages/Ebasvuru/Adaylar/CepTelConfirm";


import BasvuruForm from "./pages/Ebasvuru/BasvuruForm/BasvuruForm";
import { ShareProvider } from "./pages/Ebasvuru/BasvuruForm/BasvuruContext";
import LoginPagev2 from "./pages/login/SGK/LoginPagev2";
import LogoutPage from "./pages/login/SGK/LogoutPage";
import AdayKimlikBilgisi from "./pages/Ebasvuru/Adaylar/AdayKimlikBilgisi";
import AdayLogin from "./pages/login/aday/AdayLogin";
import IlanDetay from "./pages/Ebasvuru/Adaylar/IlanDetay";
import Ilanlar from "./pages/Ebasvuru/Adaylar/Ilanlar";
import AdayConfirmKodu from "./pages/Ebasvuru/Adaylar/AdayConfirmKodu";
import TestMerkeziPage from "./pages/testmerkezi/TestMerkeziPage";





const themeOptions = {
    components: {
        MuiTextField: {
            defaultProps: {
                size: "small",
            },
            styleOverrides: {
                root: {
                    background: "white"
                }
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true
            }
        }
    },
    palette: {
        primary: {
            main: '#6143D8',
        },
        secondary: {
            main: '#DDD4FF',
        },
        info: {
            main: '#dfdfdf'
        },
        danger: {
            main: '#ff1744',
            contrastText: '#ffffff'  // White text
        },
        text: {
            primary: '#052a52',
            dark: '#343a40',
            body: '#212529',
            secondary: '#666666',
            success: '#28a745',
            muted: '#6c757d',
            info: '#17a2b8',
            warning: '#ffc107',
            danger: '#dc3545',
            disabled: '#BDBDBD',
            light: '#f8f9fa',
            hint: '#9E9E9E',
            menu: '#d9ecfe'
        }
    },
    typography: {
        h1: {
            fontSize: "2.5rem",
            fontWeight: 700
        },
        h2: {
            fontSize: "2rem",
            fontWeight: 700
        },
        h3: {
            fontSize: "1.75rem",
            fontWeight: 600
        },
        h4: {
            fontSize: "1.5rem",
            fontWeight: 600
        },
        h5: {
            fontSize: "1.25rem",
            fontWeight: 500
        },
        h6: {
            fontSize: "1rem",
            fontWeight: 500
        },
        subtitle1: {
            fontSize: "1rem",
            fontWeight: 400
        },
        subtitle2: {
            fontSize: "0.875rem",
            fontWeight: 400
        },
        body1: {
            fontSize: "1rem",
            fontWeight: 400
        },
        body2: {
            fontSize: "0.875rem",
            fontWeight: 400
        },
        caption: {
            fontSize: "0.75rem",
            fontWeight: 300
        },
        overline: {
            fontSize: "0.625rem",
            fontWeight: 300,
            textTransform: "uppercase"
        },
        button: {
            fontSize: "0.875rem",
            fontWeight: 600,
            textTransform: "none"
        }
    }
}

/*const locales = {
    "tr": trTR,
    "en": enUS
}*/

const MainRouterv2 = () => {

    //  const { panelLang } = useSelector(state => state.auth);

    const { getGlobal, isLoading } = useGlobal();

    const { getUser, clearUser } = useAppCookies();
    const { user } = useSelector(state => state.auth);

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);


    const [theme] = useState(
        createTheme({
            ...themeOptions
        }, trTR)
    );


    useEffect(() => {
        getGlobal();

    }, [getGlobal]);


    useEffect(() => {


        const user = getUser();
        if (user && user.accessToken) {

            switch (user.loginType) {
                case "aday":
                    dispatch({
                        type: ActionType.ADAY_LOGIN,
                        user: user,
                        loginType: "aday",
                        token: user.accessToken,
                        tenant: user.tenantName,
                        iapId: user.iapId,
                        basvuruId: user.basvuruId,
                        masterToken: user.masterToken,
                        tenantKey: user.tenantKey
                    });
                    break;
                case "admin":
                    dispatch({
                        type: ActionType.MASTER_LOGIN,
                        user: user,
                        loginType: "admin",
                        token: user.accessToken,
                        tenantUser: user.masterTenant,
                        masterUser: user.masterToken
                    });
                    break;
                case "tenant":
                    dispatch({
                        type: ActionType.LOGIN,
                        user: user,
                        loginType: "tenant",
                        token: user.accessToken,
                        tenantUser: user.masterTenant,
                        masterUser: user.masterToken
                    });
                    break;
            }

        } else {
            clearUser();
        }
        setLoading(false);
    }, [dispatch, user])



    const Loading = () => {
        return (
            <PageLoading />
        );
    };


    const { loginType } = useSelector(state => state.auth);

    if (!isLoading) {
        return <Loading />; // Optional loading state
    }

    const renderHomePage = () => {
        switch (loginType) {
            case "admin":
                return <MasterHomePage />
            case "tenant":
                return <HomePage />
            case "aday":
                return (
                    <ShareProvider >
                        <BasvuruForm />
                    </ShareProvider>
                )
        }
    };




    const SwitchView = React.memo(() => {
        return (
            <Switch>
                <Route path="/login">
                    <LoginPagev2 />
                </Route>
                <Route path="/aday">
                    <AdayLogin />
                </Route>
                <Route path='/ilanDetay'>
                    <IlanDetay />
                </Route>
                <Route path='/ilanlar'>
                    <Ilanlar />
                </Route>
                <Route path='/testmerkezi'>
                    <TestMerkeziPage />
                </Route>
                <Route path='/adayTelefonOnayi'>
                    <CepTelConfirm />
                </Route>
                <Route path='/adayonaykodu'>
                    <AdayConfirmKodu />
                </Route>
                <Route path='/adaykimlikbilgisi'>
                    <AdayKimlikBilgisi />
                </Route>
                <PrivateRoute path="/">
                    {renderHomePage()}
                </PrivateRoute>
                <Route path="/logout">
                    <LogoutPage />
                </Route>
            </Switch>
        )
    }, [loginType]);



    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                {loading ? <Loading /> : <SwitchView />}
                <ReduxNotificationHandler />

            </ThemeProvider>
        </StyledEngineProvider>
    );

}

export default MainRouterv2;
